/**
 * Geometria da mira, compartilhada pelo desenho no mapa (renderer) e pelo mostrador de ângulo da tela, para os dois mostrarem a mesma coisa.
 *
 * O ângulo do tiro é absoluto (0° = direita, anti-horário, como no protocolo). A elevação é relativa ao chão sob o personagem:
 * 0° é a inclinação dele (`tilt`, positivo quando o chão sobe para a direita) e vai até a faixa da arma, para o lado em que ele olha.
 */

/** Ângulo absoluto do tiro para uma elevação, sem limitar à faixa. */
export function aimAngle(elevation: number, facing: number, tilt = 0): number {
  return facing >= 0 ? tilt + elevation : 180 + tilt - elevation;
}

export interface AimTick {
  /** Graus acima do chão (0 até a faixa da arma). */
  elevation: number;
  /** Ângulo absoluto correspondente. */
  angle: number;
  /** De 10 em 10 graus: o palito é maior e leva o número. */
  major: boolean;
}

/** Palitos da faixa de mira, de `step` em `step` graus a partir de 0° até `range` (o limite entra mesmo que não caia num múltiplo). */
export function aimTicks(range: number, facing: number, tilt = 0, step = 5): AimTick[] {
  const ticks: AimTick[] = [];
  const last = Math.max(0, Math.floor(range));
  for (let elevation = 0; elevation <= last; elevation += step) {
    ticks.push({ elevation, angle: aimAngle(elevation, facing, tilt), major: elevation % 10 === 0 });
  }
  if (last % step !== 0) ticks.push({ elevation: last, angle: aimAngle(last, facing, tilt), major: false });
  return ticks;
}

/** Ponto a `radius` px de (`cx`, `cy`) na direção do ângulo absoluto, em coordenadas de tela (y cresce para baixo). */
export function polar(cx: number, cy: number, angleDegrees: number, radius: number): { x: number; y: number } {
  const radians = (angleDegrees * Math.PI) / 180;
  return { x: cx + Math.cos(radians) * radius, y: cy - Math.sin(radians) * radius };
}
